var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCache = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M9.975 8.28c0 .331-.252.6-.562.6s-.563-.269-.563-.6.252-.6.563-.6.562.269.562.6m1.238.6c.31 0 .562-.269.562-.6s-.252-.6-.563-.6-.562.269-.562.6.252.6.563.6M9.975 12c0 .331-.252.6-.562.6s-.563-.269-.563-.6.252-.6.563-.6.562.269.562.6m1.238.6c.31 0 .562-.269.562-.6s-.252-.6-.563-.6-.562.269-.562.6.252.6.563.6m-1.238 3.12c0 .331-.252.6-.562.6s-.563-.269-.563-.6.252-.6.563-.6.562.269.562.6m1.238.6c.31 0 .562-.269.562-.6s-.252-.6-.563-.6-.562.269-.562.6.252.6.563.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M8.625 6C8.004 6 7.5 6.537 7.5 7.2v9.6c0 .663.504 1.2 1.125 1.2h6.75c.621 0 1.125-.537 1.125-1.2V7.2c0-.663-.504-1.2-1.125-1.2zm6.75.72h-6.75c-.249 0-.45.215-.45.48v2.64h7.65V7.2c0-.265-.201-.48-.45-.48m-7.2 6.84v-3.12h7.65v3.12zm0 .6v2.64c0 .265.201.48.45.48h6.75c.248 0 .45-.215.45-.48v-2.64z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCache);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cache.b1733f5d.svg";